<div class="dashboard-view">
    <app-dates-summary
        id="dateMonitoring"
        class="dateSummary"
    ></app-dates-summary>
    <app-test-comparison
        id="testMonitoring"
        class="testComparison"
    ></app-test-comparison>
    <app-data-to-be-updated class="dataToBeUpdated"></app-data-to-be-updated>
    <app-error-log-monitoring
        class="errorLog"
        id="errorLogMonitoring"
    ></app-error-log-monitoring>
</div>
